export class MMCustomerApiUtils {
  static extractOwnerPolicyInfo(
    customerArray: CustomerAgreementApiResponse,
    sanderlingPolicyTypes: SanderlingPolicyData[]
  ): MMPolicyInfo[] {
    if (!customerArray || !customerArray.customers || !customerArray.customers.length) {
      return;
    }

    // iterate over all provided agreements
    let policyArray: MMPolicyInfo[] = [];
    for (const customer of customerArray.customers) {
      const polMap: MMPolicyInfo[] = [];
      customer.customerAgreements.forEach((agreement) => {
        // construct policy info
        const info: MMPolicyInfo = { product: agreement.agreementKeyAdmin, policyNumber: '' };
        const sanderlingType = sanderlingPolicyTypes.find((p) => p.productCode === agreement.agreementKeyAdmin);

        // determine what key sequence generates the policy number
        // only add the policy if it is a known sanderling type
        if (sanderlingType && agreement.roleType === 'OWNR') {
          sanderlingType.policyNumberKeys.forEach((key) => {
            info.policyNumber += agreement[key];
            // trim leading 0s if there are any
            info.policyNumber = info.policyNumber ? info.policyNumber.replace(/^0+/, '') : '';
          });
        }

        // only save the policy if we could map a policy number
        if (info.policyNumber) {
          polMap.push(info);
        }
      });

      policyArray = policyArray.concat(polMap);
    }
    return policyArray;
  }
}

export interface SanderlingPolicyData {
  policyNumberKeys: string[];
  productCode: string;
}

export class MMPolicyInfo {
  product: string;
  policyNumber: string;
}

export interface SanderlingPolicyTypes {
  productCode: string;
  policyNumberKeys: string[];
}

export interface CustomerAgreementApiResponse {
  customers: AgreementCustomer[];
}

export interface AgreementCustomer {
  memberId: string;
  memberGUID?: string;
  cpGUID?: string;

  /**
   * Holds all policy information
   */
  customerAgreements: Agreement[];
}

export interface Agreement {
  agreementKey: string;

  /**
   * Product Type of the policy
   */
  agreementKeyAdmin: string;

  /**
   * Policy number (for most MM policies)
   *
   * - mmtrad: policy number in full
   * - OPM: policy number in full
   * - PE1: _partial policy number_; full policy numbers also contain a prefix and suffix
   * - MPR: _partial policy number_; full policy numbers also contain a prefix and suffix
   */
  agreementKeyPrimary: string;
  roleType: string;
  roleSubType: string;
  statusCode: string;
  statusReasonCode: string;
  productId: string;
  links: { rel: string; href: string }[];
}

export interface CustomerApiConfigs {
  client_secret: string;
  apiDomain: string;
  apiScope: string;
  client_id: string;
  grant_type: string;
}
